import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './gtm';

/**
 * Every path here is `/<uuid>`, which is a share token for a customer's
 * quotation — so the route is reported under a fixed name rather than its own
 * pathname. Sending the raw path would put that token in GA4.
 */
export function usePageView(pageName: string): void {
  const location = useLocation();

  useEffect(() => {
    trackPageView(pageName);
  }, [pageName, location.pathname]);
}
